<template>
    <div id="advanced-claim-search-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Advanced Claim Search</h5>
                </div>
                <div class="modal-body">
                    <input type="text" class="form-control form-control-sm my-2" placeholder="PAN" v-model="criteria.pan">
                    <input ref="dos" type="text" class="form-control form-control-sm my-2" placeholder="DOS" v-model="criteria.dos" onfocus="(this.type='date')">
                    <input type="text" class="form-control form-control-sm my-2" placeholder="Patient Last Name" v-model="criteria.patientLast">
                    <input type="text" class="form-control form-control-sm my-2" placeholder="Patient First Name" v-model="criteria.patientFirst">
                    <input v-if="!historical" type="text" class="form-control form-control-sm my-2" placeholder="Transaction Code" v-model="criteria.transactionCode">
                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset</a>
                    <button class="btn btn-primary" data-dismiss="modal" @click="search(criteria)">Search</button>
                    <button class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        search: Function
    },
    data() {
        return {
            historical: false,
            criteria: {
                pan: null,
                dos: null,
                patientLast: null,
                patientFirst: null,
                transactionCode: null
            }
        }
    },
    methods: {
        show: function (historical = false) {

            // if the dos is empty make sure we reset the input type so we can see the placeholder 
            if (!this.$refs.dos.value) this.$refs.dos.type='text';

            this.historical = historical;
            $('#advanced-claim-search-modal').modal('show');
        },
        reset: function () {

            this.criteria.pan = null;
            this.criteria.dos = null;
            this.$refs.dos.type='text';
            this.criteria.patientLast = null;
            this.criteria.patientFirst = null;
            this.criteria.transactionCode = null;
        }
    },   
    created() {
        eventHub.$on('show-advanced-claim-search', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-advanced-claim-search');
    },
}
</script>

<style scoped>

</style>